import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {AppThunk} from './store';

interface ApiState {
    isLoading: boolean,
    loadingProcList: string[]
}

const initialState: ApiState = {
    isLoading: false,
    loadingProcList: []
}

interface LoadingPayload {
    proc: string,
    silent: boolean
}

const apiSlice = createSlice({
   name: 'api',
   initialState,
   reducers: {
       startLoading: {
           reducer: (state, action: PayloadAction<LoadingPayload>) => {
               const {proc, silent} = action.payload;
               if (!silent)
                   state.isLoading = true;
               if (state.loadingProcList.indexOf(proc) < 0){
                   state.loadingProcList.push(proc);
               }
           },
           prepare: (proc: string, silent: boolean = false) => {
               return { payload: {proc, silent}};
           }
       },
       endLoading: {
           reducer: (state, action: PayloadAction<LoadingPayload>) => {
               const {proc, silent} = action.payload;
               if (!silent) 
                   state.isLoading = false;
               const idx = state.loadingProcList.indexOf(proc);
               if (idx > -1){
                   state.loadingProcList.splice(idx, 1);
               }
           },
           prepare: (proc: string, silent: boolean = false) => {
               return { payload: {proc, silent}};
           }
       }
   } 
});

export const {startLoading, endLoading} = apiSlice.actions;
export default apiSlice.reducer;